module.exports = __webpack_public_path__ + "media/src/assets/images/axis-x-c73f8e5021aabf4c73d684bc348c266f.png";